import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { Subscription, Invoice, Plan } from '../types'

export const subscriptionApi = {
  fetchSubscription: () =>
    apiClient.get<ApiResponse<Subscription>>('/me/subscription'),

  createSubscription: (plan: Plan, stripeToken: string) =>
    apiClient.post<ApiResponse<Subscription>>('/me/subscription', {
      plan,
      stripe_token: stripeToken,
    }),

  cancelSubscription: () => apiClient.delete<void>('/me/subscription'),

  changePlan: (plan: Plan) =>
    apiClient.put<ApiResponse<Subscription>>('/me/subscription/plan', { plan }),

  fetchInvoices: () =>
    apiClient.get<ApiResponse<Invoice[]>>('/me/subscription/invoices'),

  fetchPortalUrl: () =>
    apiClient.get<ApiResponse<{ url: string }>>('/me/subscription/portal'),
}
